import {Component} from '@angular/core';
import {AbstractControl, FormControl, ValidationErrors, Validators} from '@angular/forms';
import {NastaveniUcetniJednotkyDto} from '../nastaveni-ucetni-jednotka-data/models/NastaveniUcetniJednotkaDtos';
import {DetailComponent} from '../shared/detail/detail.component';
import {Field} from '../shared/detail/detail.service';
import {NastaveniUcetniJednotkaService} from './nastaveni-ucetni-jednotka-detail.service';


@Component({
    selector: 'cml-nastaveni-ucetni-jednotka',
    templateUrl: './nastaveni-ucetni-jednotka.component.html',
    styleUrls: ['./nastaveni-ucetni-jednotka.component.scss'],
    providers: [NastaveniUcetniJednotkaService],
    standalone: false
})
export class NastaveniUcetniJednotkyComponent extends DetailComponent {

  override createFormControl(field: Field, value: any): AbstractControl {
    const validationRules: ValidationErrors = [];
    if (field.required) {
      validationRules['push'](Validators.required);
    }
    let valueUcetniJednotka = this.findField(field);
    if (valueUcetniJednotka) {
      value = valueUcetniJednotka.hodnota;
    }
    let boolValueUcetniJedntoka = (value =="True");
    return new FormControl(boolValueUcetniJedntoka, validationRules);
  }

  override async ngOnInit()
  {
    this.initialiseState();
  }

  navigateToDetail() {
    this.router.navigateByUrl(this.router.url.replace(/\/nastaveni-ucetni-jednotky$/g, ''));
  }

  override fillEntityFromForm() {
    const formValue = this.form.value;
    for (let field of this.fields) {
      let found = this.findField(field);
      if (field.type === 'autocomplete' && field.observable) {
        found!.hodnota = this.capitalizeFirstLetter(formValue[field.name][field.observable.optionValue].toString());
      } else {
        found!.hodnota = this.capitalizeFirstLetter(formValue[field.name].toString());
      }
    }
  }

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  private findField(field: Field){
    return (this.entity.nastaveniUcetniJednotky as Array<NastaveniUcetniJednotkyDto>).find(x => x.kod == field.name || x.kod == field.title)
  }

  override async save() {
    if (this.form.valid)
    {
      try
      {
        this.fillEntityFromForm();
        for (let field of this.fields)
        {
          const obj = this.findField(field)
          await this.detailService.create(this.entityId, obj);
        }
      }
      catch (e)
      {
        this.detailService.baseCrudService.api.isBusy$.next(false);
        }
    }
    else
    {
      let errors = this.getFormValidationErrors();
      if (errors.length > 0)
      {
        await this.dialogService.alert({title: "Validace", detail: errors.join('<br><br>')});
      }
    }
  }

  getFullName(): string
  {
    return this.entity.kod + " - " + this.entity.nazev
  }
}
